import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const PageTriggers = ({ currentPage, totalPages }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isHoveringLeft, setIsHoveringLeft] = useState(false);
  const [isHoveringRight, setIsHoveringRight] = useState(false);

    // If there's only one page or no pages, don't render anything
  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('page', newPage);
      setSearchParams(newSearchParams);
    }
  };

  return (
    <>
      <div
        className={`position-absolute top-0 start-0 h-100 d-none d-md-block ${
          currentPage === 1 ? '' : 'cursor-left hover-overlay'
        }`}
        style={{
          width: '5%',
          zIndex: 50
        }}
        onMouseEnter={() => setIsHoveringLeft(true)}
        onMouseLeave={() => setIsHoveringLeft(false)}
        onClick={() => handlePageChange(currentPage - 1)}
      >

      </div>

      <div
        className={`position-absolute top-0 end-0 h-100 d-none d-md-block ${
          currentPage === totalPages ? '' : 'cursor-right hover-overlay'
        }`}
        style={{
          width: '5%',
          zIndex: 50
        }}
        onMouseEnter={() => setIsHoveringRight(true)}
        onMouseLeave={() => setIsHoveringRight(false)}
        onClick={() => handlePageChange(currentPage + 1)}
      >

      </div>

      <style>
        {`
          .cursor-left {
            cursor: url('images/cursor-gal-back.png'), pointer !important;
          }
          
          .cursor-right {
            cursor: url('images/cursor-gal-forward.png'), pointer !important;
          }
          
          .hover-overlay:hover {
            background-color: rgba(0, 0, 0, 0.05);
            transition: background-color 0.3s ease;
          }
        `}
      </style>
    </>
  );
};

export default PageTriggers;